// MixpanelChores.js
import { connect } from 'react-redux';

import MixpanelChores from '../component/MixpanelChores.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  ANALYTICS_TRACKING_PUBSUB_TOPIC,
  ANALYTICS_TRACKING_PUBSUB_PREFIX,
  ANALYTICS_TRACKING_PUBSUB_POSTFIX,
  MIXPANEL_INIT_EVENTS,
  MIXPANEL_REPLAY_RECORD_TRIGGERS,
} from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    pubSubTopic: getRemoteConfigData(state, ANALYTICS_TRACKING_PUBSUB_TOPIC),
    pubSubPrefix: getRemoteConfigData(state, ANALYTICS_TRACKING_PUBSUB_PREFIX),
    pubSubPostfix: getRemoteConfigData(
      state,
      ANALYTICS_TRACKING_PUBSUB_POSTFIX
    ),
    mixpanelInitEvents: getRemoteConfigData(state, MIXPANEL_INIT_EVENTS),
    replayRecordConfig: getRemoteConfigData(
      state,
      MIXPANEL_REPLAY_RECORD_TRIGGERS
    ),
  };
};

export default connect(mapStateToProps)(MixpanelChores);
